import React from "react";
import { cn } from "../../../lib/cn";

/**
 * KpiCard — ui-v2.5. Métrica única. Se usa en rejilla de 4–5 sobre la tabla.
 * Especificación: ui-v2.5-catalogo-componentes.html · sección KpiCard.
 *
 * <KpiCard icon={Loader2} label="En curso" value={3} />
 * <KpiCard icon={Inbox} label="Datos recibidos" value={1} note="a completar" tone="received" />
 * <KpiCard icon={Filter} label="Completadas" value={12} note="filtro activo"
 *          tone="active" active onClick={...} />   // seleccionada = filtro activo
 *  - tone: colorea el VALOR con el fg del estado (waiting|received|progress|active|expired|info).
 *  - active: estado de filtro seleccionado (borde/fondo prefill, etiqueta y nota en #0369a1).
 */

const valueTone = {
  waiting:  "text-v25-waiting-fg",
  received: "text-v25-received-fg",
  progress: "text-v25-progress-fg",
  active:   "text-v25-active-fg",
  expired:  "text-v25-expired-fg",
  info:     "text-v25-info-fg",
};

export function KpiCard({ icon: Icon, label, value, note, tone, active = false, onClick, className }) {
  const Comp = onClick ? "button" : "div";
  return (
    <Comp
      type={onClick ? "button" : undefined}
      onClick={onClick}
      className={cn(
        "block w-full rounded-v25-lg border px-4 py-3.5 text-left transition-colors",
        active ? "border-v25-prefill-bd bg-v25-prefill-bg" : "border-v25-line bg-v25-surface",
        onClick && "cursor-pointer focus-visible:outline-none focus-visible:shadow-v25-focus",
        className
      )}
    >
      <div className={cn("flex items-center gap-2 text-xs font-medium", active ? "text-v25-prefill-fg" : "text-v25-ink-500")}>
        {Icon && <Icon className="h-4 w-4" />}
        {label}
      </div>
      <div className={cn("mt-1 text-2xl font-semibold", tone ? valueTone[tone] : "text-v25-ink-900")}>{value}</div>
      {note && <div className={cn("mt-0.5 text-[11px]", active ? "text-v25-prefill-fg" : "text-v25-ink-400")}>{note}</div>}
    </Comp>
  );
}
